import { render, staticRenderFns } from "./AppAddUpdateModal.vue?vue&type=template&id=04c5a0fe&scoped=true&"
import script from "./AppAddUpdateModal.vue?vue&type=script&lang=js&"
export * from "./AppAddUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c5a0fe",
  null
  
)

export default component.exports